import { entityStore, Measurements, getBinLevelMeasurementOverrides } from '~/utility/BinSentry-ui-utility';
import { LitEntity, SirenActionMixin, html, css, renderIf } from '../utility/lit-entity';
import { sharedStyles } from '../styles/shared-styles';
import '../common/bn-map';
import '../common/bn-map-marker';
import '../organizations/parts/organization-ancestors-bread-crumbs';
import './parts/bin-map-marker';

class MapIndex extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.binsHref = '';
    this.bins = [];
  }

  static get properties() {
    return {
      binsHref: { type: String, attribute: false },
      bins: { type: Array, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
        height: calc(100% - 20px);
      }
      bn-map {
        height: calc(100% - 100px);
      }
      organization-ancestors-bread-crumbs {
        margin-bottom: 1em;
        display: block;
      }
    `];
  }

  render() {
    const { href, binsHref } = this;

    return html`
      <h1>Map</h1>
      <organization-ancestors-bread-crumbs
        .href="${href}"
        linkPath="/map"
        singleLine
        ancestorMinIndex="0"
      ></organization-ancestors-bread-crumbs>
      <bn-map id="map" zoom="10">
        ${this.bins.map((bin) => this._renderMarker(bin))}
      </bn-map>
      <lit-entity .href="${binsHref}" @update="${this._onBinsUpdate}"></lit-entity>
    `;
  }

  _renderMarker(bin) {
    if (!bin.properties.location.latitude || !bin.properties.location.longitude) {
      return html``;
    }
    return html`
      <bin-map-marker
        .longitude="${bin.properties.location.longitude}"
        .latitude="${bin.properties.location.latitude}"
      >
        <div class="name">${bin.properties.name}</div>
        ${bin.level}
      </bin-map-marker>
    `;
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    this.binsHref = this.getHref('https://api.binsentry.com/rel/v2/bins');
  }

  async _onBinsUpdate(e) {
    if (this.loading) {
      return;
    }
    this.bins = [];
    const emptyBinsEntity = e.detail.entity;
    if (!emptyBinsEntity) {
      return;
    }

    this.loading = true;

    const action = emptyBinsEntity.getActionByName('limit');
    action.getField('limit').value = 200;
    const { entity } = await this.submitAction(action);

    const bins = entity.getSubEntitiesByRel('https://api.binsentry.com/rel/bin');
    let nextLink = entity.getLink('next');
    while (nextLink) {
      const nextEntity = await this.fetchSiren(nextLink.href);
      bins.push(...nextEntity.getSubEntitiesByRel('https://api.binsentry.com/rel/bin'));
      nextLink = nextEntity.getLink('next');
    }

    // fetch bin levels
    await Promise.all(bins.map(async (bin) => {
      const { href } = bin.getSubEntityByRel('https://api.binsentry.com/rel/bin-level-latest');
      const { entity } = await entityStore.fetchWait(href);
      if (!entity) {
        bin.level = html``;
        return;
      }

      const measurement = Measurements.get('binLevel', await getBinLevelMeasurementOverrides(bin));
      const { bulkDensity, volumes } = bin.properties;
      const { volume } = entity.properties;
      bin.level = html`
        ${measurement.html({ volume, totalVolume: volumes.total, bulkDensity })}
        ${renderIf(measurement.unit !== '%', () => html`
          / ${measurement.html({ volume: volumes.total, totalVolume: volumes.total, bulkDensity })}
        `)}
      `;
    }));
    // update bin list to kick of render
    this.bins = bins;
    this.loading = false;
  }
}

window.customElements.define('map-index', MapIndex);
